export * from "./core";

import { usersEndpoints as __usersAuthored } from "./users";
import { scriptsEndpoints as __scriptsAuthored } from "./scripts";
import { reportTemplatesEndpoints as __reportTemplatesAuthored } from "./reportTemplates";
import { projectsEndpoints as __projectsAuthored } from "./projects";
import { tokensEndpoints as __tokensAuthored } from "./tokens";
import { tagsEndpoints as __tagsAuthored } from "./tags";
import { dataSourcesEndpoints as __dataSourcesAuthored } from "./dataSources";
import { logsEndpoints as __logsAuthored } from "./logs";
import { runnerEndpoints as __runnerAuthored } from "./runner";
import { stepsEndpoints as __stepsAuthored } from "./steps";
import { numberSequencesEndpoints as __numberSequencesAuthored } from "./numberSequences";
import { globalVariablesEndpoints as __globalVariablesAuthored } from "./globalVariables";
import { variablesEndpoints as __variablesAuthored } from "./variables";
import { kpisEndpoints as __kpisAuthored } from "./kpis";
import { workItemsEndpoints as __workItemsAuthored } from "./workItems";
import { issueTrackingToolsEndpoints as __issueTrackingToolsAuthored } from "./issueTrackingTools";
import { localizationsEndpoints as __localizationsAuthored } from "./localizations";
import { systemsEndpoints as __systemsAuthored } from "./systems";
import { exportEndpoints as __exportAuthored } from "./export";
import { mailEndpoints as __mailAuthored } from "./mail";
import { auditTrailEndpoints as __auditTrailAuthored } from "./auditTrail";
import { screenshotsEndpoints as __screenshotsAuthored } from "./screenshots";
import { biEndpoints as __biAuthored } from "./bi";
import { dashboardEndpoints as __dashboardAuthored } from "./dashboard";
import { oauthEndpoints as __oauthAuthored } from "./oauth";
import { samlEndpoints as __samlAuthored } from "./saml";
import { licenseEndpoints as __licenseAuthored } from "./license";
import { platformsEndpoints as __platformsAuthored } from "./platforms";
import { aiEndpoints as __aiAuthored } from "./ai";
import { chatsEndpoints as __chatsAuthored } from "./chats";
import { guardsEndpoints as __guardsAuthored } from "./guards";
import { codeTemplatesEndpoints as __codeTemplatesAuthored } from "./codeTemplates";
import { virtualUsersEndpoints as __virtualUsersAuthored } from "./virtualUsers";
import { schedulersEndpoints as __schedulersAuthored } from "./schedulers";
import { documentationsEndpoints as __documentationsAuthored } from "./documentations";
import { settingsEndpoints as __settingsAuthored } from "./settings";
import { notificationsEndpoints as __notificationsAuthored } from "./notifications";
import { executionEndpoints as __executionAuthored } from "./execution";
import { scriptChangeLogEndpoints as __scriptChangeLogAuthored } from "./scriptChangeLog";
import { projectsCategoryEndpoints as __projectsCategoryAuthored } from "./projectsCategory";
import { ea4discoveryEndpoints as __ea4discoveryAuthored } from "./ea4discovery";
import { backgroundEndpoints as __backgroundAuthored } from "./background";
import { queuesEndpoints as __queuesAuthored } from "./queues";
import { setupEndpoints as __setupAuthored } from "./setup";
import { aiOptimizerEndpoints as __aiOptimizerAuthored } from "./aiOptimizer";

// Build a typed registry without constructing a giant literal (faster type-checking)
type AllEndpoints = typeof __usersAuthored &
  typeof __scriptsAuthored &
  typeof __reportTemplatesAuthored &
  typeof __projectsAuthored &
  typeof __tokensAuthored &
  typeof __tagsAuthored &
  typeof __dataSourcesAuthored &
  typeof __logsAuthored &
  typeof __runnerAuthored &
  typeof __stepsAuthored &
  typeof __numberSequencesAuthored &
  typeof __globalVariablesAuthored &
  typeof __variablesAuthored &
  typeof __kpisAuthored &
  typeof __workItemsAuthored &
  typeof __issueTrackingToolsAuthored &
  typeof __localizationsAuthored &
  typeof __systemsAuthored &
  typeof __exportAuthored &
  typeof __mailAuthored &
  typeof __auditTrailAuthored &
  typeof __screenshotsAuthored &
  typeof __biAuthored &
  typeof __dashboardAuthored &
  typeof __oauthAuthored &
  typeof __samlAuthored &
  typeof __licenseAuthored &
  typeof __platformsAuthored &
  typeof __aiAuthored &
  typeof __chatsAuthored &
  typeof __guardsAuthored &
  typeof __codeTemplatesAuthored &
  typeof __virtualUsersAuthored &
  typeof __schedulersAuthored &
  typeof __documentationsAuthored &
  typeof __settingsAuthored &
  typeof __notificationsAuthored &
  typeof __executionAuthored &
  typeof __ea4discoveryAuthored &
  typeof __scriptChangeLogAuthored &
  typeof __projectsCategoryAuthored &
  typeof __backgroundAuthored &
  typeof __queuesAuthored &
  typeof __setupAuthored &
  typeof __aiOptimizerAuthored;

const __E = {} as AllEndpoints;
Object.assign(
  __E,
  __usersAuthored,
  __scriptsAuthored,
  __reportTemplatesAuthored,
  __projectsAuthored,
  __tokensAuthored,
  __tagsAuthored,
  __dataSourcesAuthored,
  __logsAuthored,
  __runnerAuthored,
  __stepsAuthored,
  __numberSequencesAuthored,
  __globalVariablesAuthored,
  __variablesAuthored,
  __kpisAuthored,
  __workItemsAuthored,
  __issueTrackingToolsAuthored,
  __localizationsAuthored,
  __systemsAuthored,
  __exportAuthored,
  __mailAuthored,
  __auditTrailAuthored,
  __screenshotsAuthored,
  __biAuthored,
  __dashboardAuthored,
  __oauthAuthored,
  __samlAuthored,
  __licenseAuthored,
  __platformsAuthored,
  __aiAuthored,
  __chatsAuthored,
  __guardsAuthored,
  __codeTemplatesAuthored,
  __virtualUsersAuthored,
  __schedulersAuthored,
  __documentationsAuthored,
  __settingsAuthored,
  __notificationsAuthored,
  __executionAuthored,
  __scriptChangeLogAuthored,
  __projectsCategoryAuthored,
  __ea4discoveryAuthored,
  __backgroundAuthored,
  __queuesAuthored,
  __setupAuthored,
  __aiOptimizerAuthored,
);

export const ENDPOINTS = __E;
export type EndpointKey = keyof AllEndpoints;
export type EndpointType = AllEndpoints[keyof AllEndpoints];
